 import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbItem, BreadcrumbService } from './breadcrumb.service';
import { IconComponent } from '../icons/icon-reusable';
import { DashboardIcon, type IconDef } from '../icons/icon';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  template: `<div class="flex flex-wrap items-center text-sm leading-none">

  <ng-container *ngFor="let item of displayBreadcrumbs; let last = last">
    <span class="inline-flex h-8 items-center align-middle">
      <a
        *ngIf="item.icon"
        [routerLink]="item.routerLink"
        class="items-center justify-center rounded-lg text-slate700 align-middle"
      >
        <app-icon-reusable [icon]="resolveIcon(item.icon)" [size]="18"></app-icon-reusable>
      </a>
      <a
        *ngIf="!item.icon && item.routerLink"
        [routerLink]="item.routerLink"
        class="inline-flex h-8 items-center rounded-md px-2 align-middle transition"
        [ngClass]="last && displayBreadcrumbs.length > 1 ? 'text-orange600' : 'text-slate900 hover:bg-slate100'"
        [style.color]="last && displayBreadcrumbs.length > 1 ? '#EA580C' : null"
      >
        <span class="inline-flex items-center leading-none">{{ item.label }}</span>
      </a>
      <span
        *ngIf="!item.icon && !item.routerLink"
        class="inline-flex h-8 items-center rounded-md px-2 align-middle"
        [ngClass]="last && displayBreadcrumbs.length > 1 ? 'text-orange600' : 'text-slate900'"
        [style.color]="last && displayBreadcrumbs.length > 1 ? '#EA580C' : null"
      >
        <span class="inline-flex items-center leading-none">{{ item.label }}</span>
      </span>
    </span>
    <span
      *ngIf="!last"
      class="inline-flex h-8 items-center self-center px-1 align-middle text-neutral400"
    >
      <svg viewBox="0 0 16 16" class="h-3 w-3 fill-none stroke-current" stroke-width="1.8">
        <path d="m6 3 4 5-4 5"></path>
      </svg>
    </span>
  </ng-container>
</div>`,
})
export class BreadcrumbComponent implements OnInit {
  @Input() items: BreadcrumbItem[] | null = null;
  @Input() iconOverride: IconDef | null = null;

  breadcrumbs: BreadcrumbItem[] = [];
  protected readonly dashboardIcon = DashboardIcon;
  protected get breadcrumbIcon(): IconDef {
    return this.iconOverride ?? this.dashboardIcon;
  }

  protected resolveIcon(icon: BreadcrumbItem['icon']): IconDef {
    if (icon && typeof icon === 'object' && 'svg' in icon) {
      return icon;
    }

    return this.breadcrumbIcon;
  }

  protected get displayBreadcrumbs(): BreadcrumbItem[] {
    return this.items ?? this.breadcrumbs;
  }

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((items) => {
      this.breadcrumbs = items;
    });
  }
}
